import { Carousel, Row, Typography } from 'antd';
import { inject, observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';
import ConsultaParticipaciones from '../images/consulta.png';
import Fondo from '../images/fondo.jpg';
import { TokenStore, UserStore } from '../stores';
import { UpdatePassword } from './AppHeader/UpdatePassword';

interface DefaultPageProps {
    userStore?: UserStore;
    tokenStore?: TokenStore;
}

const DefaultPageWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    padding: 0 40px;
    margin-top: 80px;
    max-width: 1200px;
`;

const Image = styled.img`
    flex: 0 1 400px;
    object-fit: contain;
    width: 100%;
    max-width: 400px;
    height: auto;
`;

const Spacer = styled.div`
    width: 24px;
`;

const MsgVeda = () => {
    const styleVeda = {
        backgroundColor: '#fff',
        borderColor: '#fff',
        color: '#7c7c7c',
        padding:'30px'
    };
    return (
        <>
            <Row style={{ ...styleVeda,textAlign: 'center' }}>
                <h2>ATENTO AVISO</h2>
                <h3>En apego a las acciones preventivas implementadas 
                    por la Administración Pública Estatal, con motivo del 
                    Proceso Electoral 2024, este contenido será
                    modificado temportalmente en atención a las
                    disposiciones legales y normativas en 
                    material electoral.

                </h3>
            </Row>
        </>
    );
    
}

const TitleWrapper = styled.div`
    margin-bottom: 24px;
    max-width: 1000px;
    border: 1px solid #e6e6e6 !important;
    background-color: #fff !important;
    height: 250px;
    box-shadow: 4px 4px 4px 4px #aaa

    .slick-dots > li {
        background-color: #6e6e6e !important;
    }
    .slick-dots > .slick-active>button{
        background-color: black !important;
    }
`;

const TextoCarousel = styled.div`
    color: #72706f !important;
    text-align: center;
    font-size: 40px;
    height: 250px !important;
    padding: 20px !important;
    padding-top: 50px !important;
`;

const LinkStyled = styled.a`
    color: #72706f;
    font-size: 30px;
    font-weight: bold;
    text-decoration: underline;
    :hover {
        text-decoration: underline !important;
    }
`;

@inject('authStore')
@inject('userStore')
@inject('tokenStore')
@observer
export class DefaultPage extends React.Component<DefaultPageProps, {}> {
    async componentDidMount() {
        const { userStore, tokenStore } = this.props;
        if (sessionStorage.getItem('token') !== null) {
            tokenStore!.autenticado = true;
            tokenStore!.token = sessionStorage.getItem('token');
        }
        if (tokenStore!.autenticado) {
            await userStore!.getAcciones();
        }
    }

    render() {
        const { tokenStore, userStore } = this.props;
        const { autenticado } = tokenStore!;
        const nuevaContraseña = userStore!.banderaPassword;
        const estiloFondo = {
            backgroundImage: 'url(' + Fondo + ')'
        };
        return (
            <>
                {autenticado && !nuevaContraseña ? (
                    <UpdatePassword />
                ) :
                    (autenticado && nuevaContraseña ? null :
                        (
                            <DefaultPageWrapper>
                                <TitleWrapper style={estiloFondo}>
                                    <Carousel autoplay={true} style={{ width: '1000px' }}>
                                        <TextoCarousel>
                                            Sistema de Consulta de Información de Participaciones a
                                            Municipios
                                    <br />
                                            <LinkStyled
                                                href="http://apps.sfapuebla.gob.mx/ConsultaParticipacion"
                                                target="_blank"
                                            >
                                                Ingresa aquí
                                    </LinkStyled>
                                        </TextoCarousel>
                                        <TextoCarousel>
                                            Transparencia Fiscal
                                    <br />
                                            <LinkStyled
                                                href="http://www.transparenciafiscal.puebla.gob.mx"
                                                target="_blank"
                                            >
                                                Ingresa aquí
                                    </LinkStyled>
                                        </TextoCarousel>
                                    </Carousel>
                                </TitleWrapper>
                                <Spacer />
                                {/* <MsgVeda /> */}
                            </DefaultPageWrapper>
                        )
                    )
                }
            </>
        );
    }
}
